import React from 'react';
import { useAnalytics } from '@Context/AnalyticsContext';
import AnalyticsLineChart from './AnalyticsLineChart';
import AnalyticsBarChart from './AnalyticsBarChart';
import AnalyticsPieChart from './AnalyticsPieChart';

const AnalyticsChartContainer: React.FC = () => {
  const { chartType } = useAnalytics();

  const renderChart = () => {
    switch (chartType) {
      case 'line':
        return <AnalyticsLineChart />;
      case 'bar':
        return <AnalyticsBarChart />;
      case 'pie':
        return <AnalyticsPieChart />;
      default:
        return <AnalyticsLineChart />;
    }
  };

  return <div className="w-full">{renderChart()}</div>;
};

export default AnalyticsChartContainer;
